/**
 * «29.10.2026 18:40» — a moment as an operator screen prints it (the monitor's
 * codes, the published schedule's state), in the browser's own time zone.
 */
const formatDateTime = value => {
    const date = new Date(value);

    return `${date.toLocaleDateString('uk-UA')} ${date.toLocaleTimeString('uk-UA', { hour: '2-digit', minute: '2-digit' })}`;
};

export default formatDateTime;
